import React from 'react'

const VernamCipherDecryption = ({ plainText, cipherText, finalKey }) => {

    var plainTextArray = plainText.split("");
    var cipherTextArray = cipherText.split("");
    var keyArray = finalKey.split("");

    return (
        <div>
            <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 10px 0" }}>Decryption</p>

            <div style={{ textAlign: "left", display: "flex" }}>
                <div style={{ display: "inline", textAlign: "right", minWidth: "13rem" }}>
                    <div>
                        <p style={{ display: "inline" }}>Cipher Text:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Position:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Key:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Key_Pos:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Position - Key_Pos:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Add 26 if Negative:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Plain Text:</p>
                    </div>
                </div>
                <div style={{ display: "inline" }}>
                    <div className='wrapper'>
                        {cipherTextArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>
                    <div className='wrapper'>
                        {cipherTextArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{((ch.charCodeAt(0) - 65) % 26)}</div>
                        ))}
                    </div>

                    <div className='wrapper'>
                        {keyArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>

                    <div className='wrapper'>
                        {keyArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{((ch.charCodeAt(0) - 65) % 26)}</div>
                        ))}
                    </div>

                    <div className='wrapper'>
                        {cipherTextArray.map((ch, i) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{(parseInt(((cipherTextArray[i].charCodeAt(0) - 65) % 26)) - parseInt(((keyArray[i].charCodeAt(0) - 65) % 26)))}</div>
                        ))}
                    </div>
                    <div className='wrapper'>
                        {cipherTextArray.map((ch, i) =>{ 
                            var pos = (parseInt(((cipherTextArray[i].charCodeAt(0) - 65) % 26)) - parseInt(((keyArray[i].charCodeAt(0) - 65) % 26))) < 0 ? (parseInt(((cipherTextArray[i].charCodeAt(0) - 65) % 26)) - parseInt(((keyArray[i].charCodeAt(0) - 65) % 26))) + 26 : (parseInt(((cipherTextArray[i].charCodeAt(0) - 65) % 26)) - parseInt(((keyArray[i].charCodeAt(0) - 65) % 26)));
                            return(
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ pos }</div>
                        )})}
                    </div>

                    <div className='wrapper'>
                        {plainTextArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    )
}

export default VernamCipherDecryption